import React from 'react';
import { autobind } from 'core-decorators';
import { Table } from 'reactstrap';
import { Row, Col } from 'src/componentes/grid';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import LucideIcon from 'src/componentes/lucide-icon';
import Tooltip from 'src/componentes/tooltip';
import LoadingContainer from 'src/componentes/loading-container';
import TipoAcessoLookup from 'src/lookups/tipo-acesso-estatico';
import TipoAcessoPacoteLookup from 'src/lookups/tipo-acesso-pacote';

import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';
import ClassificacaoLookup from 'src/lookups/classificacao-mo';
import Panel from 'src/componentes/panel';
import InputSearch from 'src/componentes/input-search';

@autobind
class Permissoes extends React.Component {
  static defaultProps = {
    allowEditPermissions: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      list: [],
      idsExpandidos: [],
      exibirClassificacao: this.props.exibirClassificacao,
      classificacao: null,
      searchText: '',
      filteredList: [],
    };
  }

  componentDidMount() {
    this.refresh();
  }

  componentWillUnmount() {
    clearTimeout(this.searchDebounceId);
  }

  handleChangeClassificacao(field, value) {
    this.setState({ classificacao: value });
    this.refresh(value);
  }

  refresh(classificacao) {
    this.setState({
      isLoading: true,
    });

    let { exibirClassificacao } = this.state;
    let classificacaoId = exibirClassificacao
      ? classificacao && classificacao.id != null
        ? classificacao.id
        : -1
      : null;

    if (this.props.colaboradorId) {
      http
        .post(`${this.props.urlLoad}`, {
          colaboradorId: this.props.colaboradorId,
          classificacaoId: classificacaoId,
        })
        .then((response) => {
          const newList = response?.data?.list || [];

          const filteredList =
            this.state.searchText && this.state.searchText !== ''
              ? this.getFilteredList(newList, false)
              : newList;

          this.setState({
            isLoading: false,
            ...response.data,
            filteredList,
          });
        })
        .catch((error) => {
          this.setState({
            isLoading: false,
          });
          errorHandler(error);
        });
    }
  }

  handleSearchChange(value) {
    if (value) {
      this.setState({ searchText: value.target.value });

      clearTimeout(this.searchDebounceId);
      this.searchDebounceId = setTimeout(() => {
        this.setState({ filteredList: this.getFilteredList(this.state.list) });
      }, 1000);
    }
    if (!value.target.value || value.target.value === '')
      this.setState({ idsExpandidos: [] });
  }

  getFilteredList(list, expand = true) {
    const { searchText } = this.state;
    if (!searchText || searchText === '') {
      return list;
    }

    const search = searchText.toLowerCase();
    const idsToExpand = [];

    const filterItem = (item) => {
      const descricao = item.descricao
        ? item.descricao.toString().toLowerCase()
        : '';
      const match = descricao.includes(search);

      let filhos = [];
      if (item.filhos && item.filhos.length) {
        filhos = item.filhos.map(filterItem).filter((x) => x);
      }

      if (filhos.length) {
        idsToExpand.push(
          this.props.tipo === 3 ? item.pacoteId : item.centroCustoId
        );
      }

      if (match && item.filhos && item.filhos.length > 0) {
        filhos = item.filhos;
      }

      if (match || filhos.length) {
        return { ...item, filhos };
      }

      return null;
    };

    const filteredList = (list || []).map(filterItem).filter((x) => x);

    if (expand) {
      this.setState({ idsExpandidos: idsToExpand });
    }

    return filteredList;
  }

  ehGrupo(permissao) {
    return !!(permissao.filhos && permissao.filhos.length);
  }

  estaExpandido(permissao) {
    if (this.props.tipo === 3) {
      return this.state.idsExpandidos.indexOf(permissao.pacoteId) !== -1;
    } else {
      return this.state.idsExpandidos.indexOf(permissao.centroCustoId) !== -1;
    }
  }

  toggle(permissao) {
    if (this.props.tipo === 3) {
      if (this.estaExpandido(permissao)) {
        this.setState({
          idsExpandidos: this.state.idsExpandidos.filter(
            (id) => id !== permissao.pacoteId
          ),
        });
      } else {
        this.setState({
          idsExpandidos: this.state.idsExpandidos.concat([permissao.pacoteId]),
        });
      }
    } else {
      if (this.estaExpandido(permissao)) {
        this.setState({
          idsExpandidos: this.state.idsExpandidos.filter(
            (id) => id !== permissao.centroCustoId
          ),
        });
      } else {
        this.setState({
          idsExpandidos: this.state.idsExpandidos.concat([
            permissao.centroCustoId,
          ]),
        });
      }
    }
  }

  getItemLabel(campo, item) {
    if (!item) {
      return;
    }

    if (campo.labelFunction) {
      return campo.labelFunction(item);
    }

    if (campo.labelField) {
      return item[campo.labelField];
    }

    return item;
  }

  handlePermissaoAcessoChange(permissao, valor) {
    let classificacao = this.state.classificacao;
    http
      .post(`${this.props.urlSave}`, {
        permissaoId: permissao ? permissao.id : 0,
        tipoAcessoId: valor ? valor.id : 0,
        id: permissao
          ? this.props.tipo === 3
            ? permissao.pacoteId
            : permissao.centroCustoId
          : 0,
        colaboradorId: this.props.colaboradorId,
      })
      .then((response) => {
        this.setState({
          isLoading: false,
          ...response.data,
        });
        this.refresh(classificacao);
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        errorHandler(error);
      });
  }

  handleReplicarPermissaoAcessoChange(permissao) {
    let classificacao = this.state.classificacao;
    http
      .post(`${this.props.urlReply}`, {
        colaboradorId: this.props.colaboradorId,
        permissaoId: permissao ? permissao.id : 0,
        id: permissao
          ? this.props.tipo === 3
            ? permissao.pacoteId
            : permissao.centroCustoId
          : 0,
      })
      .then((response) => {
        this.setState({
          isLoading: false,
          ...response.data,
        });
        this.refresh(classificacao);
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        errorHandler(error);
      });
  }

  renderFuncionalidade(permissao, index, level = 0, paiSelecionado) {
    let { allowEditPermissions } = this.props;

    let selecionado = permissao.selecionado;

    return [].concat(
      <tr
        key={
          this.props.tipo === 3 ? permissao.pacoteId : permissao.centroCustoId
        }
      >
        <td
          style={{
            width: '45%',
            minWidth: '45%',
            paddingLeft: level * 20,
            whiteSpace: `nowrap`,
            verticalAlign: `middle`,
          }}
        >
          {this.ehGrupo(permissao) ? (
            <LucideIcon
              icon={
                this.estaExpandido(permissao) ? `chevron-down` : `chevron-right`
              }
              size={20}
              onClick={this.toggle.bind(this, permissao)}
              style={{ cursor: 'pointer' }}
            />
          ) : (
            <div style={{ display: `inline-block`, width: 20 }}></div>
          )}
          {permissao.descricao}
        </td>
        <td style={{ width: '45%', minWidth: '45%', verticalAlign: `middle` }}>
          {this.props.tipo === 3 ? (
            <TipoAcessoPacoteLookup
              style={{ marginBottom: 0 }}
              model={{
                value: permissao.acesso,
                requestChange: this.handlePermissaoAcessoChange.bind(
                  this,
                  permissao
                ),
              }}
              disabled={!allowEditPermissions}
            />
          ) : (
            <TipoAcessoLookup
              style={{ marginBottom: 0 }}
              model={{
                value: permissao.acesso,
                requestChange: this.handlePermissaoAcessoChange.bind(
                  this,
                  permissao
                ),
              }}
              disabled={!allowEditPermissions}
            />
          )}
        </td>

        {permissao.filhos &&
        permissao.filhos.length > 0 &&
        allowEditPermissions ? (
          <td style={{ minWidth: '10%', width: '10%' }}>
            <Tooltip text={<FormattedMessage id="label.replicarParaFilhos" />}>
              <div className="d-flex items-center">
                <LucideIcon
                  icon="arrow-down-bold-circle-outline"
                  size={20}
                  onClick={this.handleReplicarPermissaoAcessoChange.bind(
                    this,
                    permissao
                  )}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </Tooltip>
          </td>
        ) : (
          <td></td>
        )}
      </tr>,
      ...(this.estaExpandido(permissao)
        ? permissao.filhos &&
          permissao.filhos.length > 0 &&
          permissao.filhos.map((m, i) =>
            this.renderFuncionalidade(
              m,
              i,
              level + 1,
              paiSelecionado || selecionado
            )
          )
        : [])
    );
  }

  render() {
    let { columns, intl } = this.props;
    let { exibirClassificacao, classificacao } = this.state;
    let list = this.state.searchText
      ? this.state.filteredList
      : this.state.list;

    return (
      <LoadingContainer isLoading={this.state.isLoading}>
        <div
          style={{ width: 187, minWidth: 187, marginBottom: '24px' }}
          className="d-inline-flex"
        >
          <InputSearch
            placeholder={intl.formatMessage({
              id: 'label.pesquisaRapida',
            })}
            autoFocus
            value={this.state.searchText}
            onChange={this.handleSearchChange}
            disabled={this.state.isLoading}
          />
        </div>

        {exibirClassificacao && (
          <Panel>
            <Row>
              <Col md={3}>
                <ClassificacaoLookup
                  clearable
                  model={{
                    label: <FormattedMessage id="label.classificacao" />,
                    value: classificacao,
                    requestChange: this.handleChangeClassificacao.bind(
                      this,
                      'classificacao'
                    ),
                  }}
                />
              </Col>
            </Row>
          </Panel>
        )}

        <Table style={{ overflowY: 'hidden' }}>
          <thead>
            <tr>
              {columns &&
                columns.length > 0 &&
                columns.map((item, index) => (
                  <th key={index}>{item.headerText}</th>
                ))}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {list &&
              list.length > 0 &&
              list.map((permissao, index) =>
                this.renderFuncionalidade(permissao, index)
              )}
          </tbody>
        </Table>
      </LoadingContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}

export default injectIntl(connect(mapStateToProps)(Permissoes));
